import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'PreLoader',
  setup(__props, { expose }) {
  expose();

  const showPreloader = ref(true);
  
  onMounted(() => {
    setTimeout(() => {
      showPreloader.value = false;
    }, 4000);
  });

const __returned__ = { showPreloader }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})